import React, { useEffect } from "react"
import { firestoreConnect, isLoaded } from "react-redux-firebase"
import Presentation from "./Presentation"
import { compose } from "redux"
import { connect } from "react-redux"
import { loadTask,loadTasksList,setState } from "../../../../middleware/tasks"
import { linkTasks } from "../../../../middleware"

function Container(props) {
  const { taskData ,_load_task,_load_taskslist,isLoadingTask,tasksListData,isLoadingTaskList} = props
  

  const [state, setState] = React.useState({
    listOfTasksToBeLinked: [],
  })


  let task = []

 let tasksListPayload = {
   projectID: props.projectId,
  }
  
 let tasksList = []

   let taskPayload = {
     taskID: props.taskId,
     projectID: props.projectId,
  }
  

   useEffect(() => {
     _load_task(taskPayload)
     _load_taskslist(tasksListPayload)

   }, [])
  
  
  const handleChange = (e, value) => {
    let taskArray = state.listOfTasksToBeLinked
    if (e.target.checked) {
      taskArray = [...taskArray, value]
    } else {
      const index = taskArray.indexOf(value)
      taskArray.splice(index, 1)
    }
    setState({
      ...state,
      listOfTasksToBeLinked: taskArray,
    })
  }



  const handleClick = (e,handleClose) => {
    e.preventDefault()
    const { link_task } = props
    let data = {
      parentTaskId: props.taskId,
      tasksToBeLinked: state.listOfTasksToBeLinked,
      projectId: props.projectId,
    }
    let payload = {
      projectID: props.projectId,
      data,
    }
    console.log(payload)
    link_task(payload,handleClose)
    // dispatch({
    //   type: LINK_TASKS,
    //   payload: {
    //     parentTaskId: state.task.id,
    //     tasksToBeLinked: this.state.listOfTasksToBeLinked,
    //     projectId: state.project.id,
    //   },
    // })
  }
  const clearValues = () => {
    setState({
      ...state,
      listOfTasksToBeLinked: "",
    })
  }
  if (isLoaded(props.project)) {
    if (!isLoadingTask && !isLoadingTaskList)  {
      task = Object.values(taskData["taskData"])
      tasksList = Object.values(tasksListData["tasksListData"].data)
      return (
        <div>
          <Presentation
            {...props}
            listOfTasksToBeLinked={state.listOfTasksToBeLinked}
            task={task}
            taskList={tasksList}
            handleChange={handleChange}
            handleClick={handleClick}
            clearValues={clearValues}
          />
        </div>
      )
    }
    return <p>Loading....</p>
  }
  return <p>Loading</p>
}

const mapStateToProps = (state, ownProps) => {
  const taskId = ownProps.taskId
  // const projectId = ownProps.projectId
  const project = state.firestore.ordered.project
  // ? state.firestore.ordered.project
  // : state.firestore.ordered.projectsList.filter(
  //     (item) => item.id === projectId
  //   )[0]

  return {
    project: project,
    taskData: state.projects.task,
    isLoadingTask: state.projects.task.taskData.isLoading,
    tasksListData: state.projects.tasksList,
    isLoadingTaskList: state.projects.tasksList.tasksListData.isLoading,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    _load_task: (payload) => {
      dispatch(loadTask(payload))
    },
    _load_taskslist: (payload) => {
      dispatch(loadTasksList(payload))
    },
    link_task: (payload,handleClose) => {
      dispatch(linkTasks(payload,handleClose))
    },
    // _un_subscribe_listener: (type) => dispatch(unSubscribeListener(type)),
    _set_state: (obj) => setState(obj),
  }
}
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
      return [
        {
          collection: "PROJECTS",
          doc: props.projectId,
          storeAs: "project",
        },
        {
          collection: "PROJECTS",
          doc: props.projectId,
          subcollections: [
            {
              collection: "TASKS",
              storeAs: "tasks",
            },
          ],
          storeAs: "taskslist",
        },
      ]
    return []
  })
)(Container)
